var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Tooltip } from "react-bootstrap";
import Info from "react-icons/lib/fa/info-circle";
import { Lato } from "../../global/fonts";
export var StyledInfo = styled(Info)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  float: right;\n  color: ", ";\n"], ["\n  float: right;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.medium;
});
export var StyledTooltip = styled(Tooltip)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  .tooltip-arrow {\n    border-top-color: ", " !important;\n    border-bottom-color: ", " !important;\n  }\n  .tooltip-inner {\n    background-color: ", ";\n    padding: 20px;\n    color: ", ";\n    ", "\n  }\n"], ["\n  .tooltip-arrow {\n    border-top-color: ", " !important;\n    border-bottom-color: ", " !important;\n  }\n  .tooltip-inner {\n    background-color: ", ";\n    padding: 20px;\n    color: ", ";\n    ", "\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.perkbox.greenBlue;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.perkbox.greenBlue;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.perkbox.greenBlue;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.white;
}, Lato);
var templateObject_1, templateObject_2;
